import { render } from "./AdminSetting.vue?vue&type=template&id=896fa75c"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__